import { render } from "./chatroom.vue?vue&type=template&id=bca6b1a2&scoped=true"
import script from "./chatroom.vue?vue&type=script&lang=js"
export * from "./chatroom.vue?vue&type=script&lang=js"

import "./chatroom.vue?vue&type=style&index=0&id=bca6b1a2&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca6b1a2"]])

export default __exports__